export default "__VITE_ASSET__Cm7qa86k__"